import { alpha,Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

declare module '@mui/material/Paper' {
  interface PaperPropsVariantOverrides {
    card: true;
  }
}

export function paper(theme: Theme) {
  return {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
        outlined: {
          borderColor: alpha(theme.palette.grey[500], 0.16),
        },
        card: {
          borderRadius: theme.shape.borderRadiusLg,
          boxShadow: theme.customShadows.card,
        },
      },
    },
  };
}
